// extracted by mini-css-extract-plugin
export default {"aboutUsDiv":"aboutUs_aboutUsDiv__tFvmE","aboutUsDetails":"aboutUs_aboutUsDetails__ONeoU","aboutUsSpan":"aboutUs_aboutUsSpan__rWm9E"};